import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { FaFacebook, FaGoogle, FaInstagram } from 'react-icons/fa';
import { API_SN_DELETE, API_GET_LINKS } from '../../../utils';
import './style.css';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Checkbox } from '../../../components/ui/checkbox';
import { Badge } from '../../../components/ui/badge';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '../../../components/ui/dialog';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription
} from '../../../components/ui/card';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '../../../components/ui/dropdown-menu';
import { initiateGoogleOAuth } from '../../../services/googleOAuth';
import { initiateFacebookOAuth } from '../../../services/facebookOAuth';
import BingLogo from '../../../Icons/bing.svg';

import {
  Home,
  Star,
  FileText,
  Image,
  Bell,
  LogOut,
  Menu,
  Facebook,
  Instagram,
  Check,
  X,
  CalendarDays,
  Building2,
  Plus,
  Link2,
  CheckCircle2,
  Unplug,
  MapPin
} from 'lucide-react';

const Links = ({ selectedClient, userInfo }) => {
  const history = useHistory();
  const [links, setLinks] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);

  // Disconnect modal states
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const [networkToDisconnect, setNetworkToDisconnect] = useState('');
  const [disconnectSuccessModalOpen, setDisconnectSuccessModalOpen] =
    useState(false);

  // Listener para mensajes del popup de OAuth
  useEffect(() => {
    const handleOAuthMessage = (event) => {
      // Verificar que el mensaje viene de nuestro dominio
      if (event.origin !== window.location.origin) return;

      if (
        event.data.type === 'GOOGLE_OAUTH_SUCCESS' ||
        event.data.type === 'FACEBOOK_OAUTH_SUCCESS'
      ) {
        console.log('OAuth completed successfully, reloading page...');
        // Recargar la página para mostrar la nueva conexión
        window.location.reload();
      }
    };

    window.addEventListener('message', handleOAuthMessage);

    return () => {
      window.removeEventListener('message', handleOAuthMessage);
    };
  }, []);

  // Función para iniciar OAuth de Google
  const handleConnectGoogle = () => {
    const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT_URI;

    // State incluye el clientId de la plataforma para saber a quien asociar los tokens
    const state = encodeURIComponent(
      JSON.stringify({
        clientId: selectedClient.id,
        platform: 'adlersuite'
      })
    );

    initiateGoogleOAuth(clientId, redirectUri, state);
  };

  // Función para iniciar OAuth de Facebook
  const handleConnectFacebook = () => {
    initiateFacebookOAuth(selectedClient.id);
  };

  // Function to disconnect social networks
  const disconnectSocialNetwork = async (network, clientId) => {
    setNetworkToDisconnect(network);
    setDisconnectModalOpen(true);
  };

  const confirmDisconnect = async () => {
    const network = networkToDisconnect;
    const clientId = selectedClient.id;

    setDisconnectModalOpen(false);

    await axios
      .delete(API_SN_DELETE, {
        data: {
          socialNetwork: network,
          id: clientId
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setDisconnectSuccessModalOpen(true);
        }
      });
  };

  useEffect(() => {
    if (!links) {
      const clientSocialNetworksLinks = async (clientId) => {
        try {
          const { Links } = await (
            await fetch(API_GET_LINKS + new URLSearchParams({ clientId }))
          ).json();
          if (links === null) {
            setLinks(Links);
          }
        } catch (error) {
          console.error('The link have an error', error);
        }
      };
      if (selectedClient.id && links === null) {
        clientSocialNetworksLinks(selectedClient.id);
      }
    }
  }, [selectedClient.id, links]);

  return (
    <>
      <Card className="shadow-md rounded-2xl border-0">
        <CardHeader className="flex flex-row items-center justify-between pb-4 pt-6 px-6 lg:px-8">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center">
              <Link2 className="h-6 w-6 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl lg:text-2xl font-bold">
                Connected Accounts
              </CardTitle>
              <CardDescription className="text-base mt-1">
                Your social media and business listings
              </CardDescription>
            </div>
          </div>

          <div className="relative">
            <Button
              type="button"
              size="lg"
              onClick={() => setShowDropdown(!showDropdown)}
              className="gap-3 h-12 px-6 text-base font-semibold rounded-xl">
              <Plus className="h-5 w-5" />
              Add Account
            </Button>

            {showDropdown && (
              <>
                <div
                  className="fixed inset-0 z-40"
                  onClick={() => setShowDropdown(false)}
                />
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl border border-gray-200 shadow-xl z-50 p-2">
                  <button
                    type="button"
                    onClick={() => {
                      handleConnectFacebook();
                      setShowDropdown(false);
                    }}
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors">
                    <div className="h-8 w-8 rounded-full bg-blue-600 flex items-center justify-center">
                      <Facebook className="h-4 w-4 text-white" />
                    </div>
                    <span className="font-medium">Facebook</span>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      handleConnectGoogle();
                      setShowDropdown(false);
                    }}
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors">
                    <div className="h-8 w-8 rounded-full bg-white border border-gray-200 flex items-center justify-center">
                      <svg className="h-4 w-4" viewBox="0 0 24 24">
                        <path
                          fill="#4285F4"
                          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        />
                        <path
                          fill="#34A853"
                          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        />
                        <path
                          fill="#FBBC05"
                          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        />
                        <path
                          fill="#EA4335"
                          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        />
                      </svg>
                    </div>
                    <span className="font-medium">Google Business</span>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      handleConnectFacebook();
                      setShowDropdown(false);
                    }}
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors">
                    <div className="h-8 w-8 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 flex items-center justify-center">
                      <Instagram className="h-4 w-4 text-white" />
                    </div>
                    <span className="font-medium">Instagram</span>
                  </button>

                  <div className="h-px bg-gray-200 my-2" />

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 rounded-full bg-white shadow-sm border border-gray-200 flex items-center justify-center overflow-hidden">
                      <img
                        src={BingLogo}
                        alt="Bing"
                        className="h-6 w-6 object-contain"
                      />
                    </div>
                    <span className="font-medium">Bing Places</span>
                  </button>

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center">
                      <svg
                        className="h-4 w-4 text-white"
                        viewBox="0 0 24 24"
                        fill="currentColor">
                        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z" />
                      </svg>
                    </div>
                    <span className="font-medium">TikTok</span>
                  </button>

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 flex items-center justify-center text-black">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="currentColor">
                        <path d="M20 6.009h-2.829C15.211 4.675 12.813 4 10 4s-5.212.675-7.171 2.009H0c.428.42.827 1.34.993 2.04A4.954 4.954 0 0 0 0 11.008c0 2.757 2.243 5 5 5a4.97 4.97 0 0 0 3.423-1.375L10 17l1.577-2.366A4.97 4.97 0 0 0 15 16.01c2.757 0 5-2.243 5-5 0-1.112-.377-2.13-.993-2.96.166-.7.565-1.62.993-2.04z" />
                      </svg>
                    </div>
                    <span className="font-medium">TripAdvisor</span>
                  </button>

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center">
                      <MapPin className="h-4 w-4 text-white" />
                    </div>
                    <span className="font-medium">Apple Maps</span>
                  </button>

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 rounded-full bg-[#0061A8] flex items-center justify-center">
                      <span className="text-white text-xs font-bold">BBB</span>
                    </div>
                    <span className="font-medium">Better Business Bureau</span>
                  </button>

                  <button
                    type="button"
                    className="w-full flex items-center gap-3 cursor-pointer py-3 px-4 rounded-lg text-base hover:bg-gray-100 transition-colors text-gray-400">
                    <div className="h-8 w-8 flex items-center justify-center text-[#FF1A1A]">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 16 16"
                        fill="currentColor">
                        <path d="m4.188 10.095.736-.17.073-.02A.813.813 0 0 0 5.45 8.65a1 1 0 0 0-.3-.258 3 3 0 0 0-.428-.198l-.808-.295a76 76 0 0 0-1.364-.493C2.253 7.3 2 7.208 1.783 7.14c-.041-.013-.087-.025-.124-.038a2.1 2.1 0 0 0-.606-.116.72.72 0 0 0-.572.245 2 2 0 0 0-.105.132 1.6 1.6 0 0 0-.155.309c-.15.443-.225.908-.22 1.376.002.423.013.966.246 1.334a.8.8 0 0 0 .22.24c.166.114.333.129.507.141.26.019.513-.045.764-.103l2.447-.566z" />
                      </svg>
                    </div>
                    <span className="font-medium">Yelp</span>
                  </button>
                </div>
              </>
            )}
          </div>
        </CardHeader>
        <CardContent className="px-6 lg:px-8 pb-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {/* Facebook */}
            <div className="p-5 rounded-xl border-2 border-border bg-background hover:border-primary/30 transition-colors">
              <div className="flex items-center gap-4 mb-4">
                <div className="h-14 w-14 rounded-full bg-blue-600 flex items-center justify-center shadow-lg flex-shrink-0">
                  <Facebook className="h-7 w-7 text-white" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-lg">Facebook</p>
                  {links?.Facebook_URL &&
                  selectedClient.socialnetworks.facebookPage ? (
                    <a
                      className="text-sm text-muted-foreground truncate block"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={links?.Facebook_URL}>
                      {selectedClient.socialnetworks.facebookPage}
                    </a>
                  ) : (
                    <p className="text-sm text-muted-foreground truncate">
                      Not connected
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between gap-3">
                {links?.Facebook_URL &&
                selectedClient.socialnetworks.facebookPage ? (
                  <>
                    <Badge className="bg-green-100 text-green-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" /> Connected
                    </Badge>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      className="text-destructive hover:text-destructive hover:bg-destructive/10 gap-2 rounded-lg"
                      style={{
                        background: 'none',
                        cursor: 'pointer',
                        outline: 'inherit'
                      }}
                      onClick={() => {
                        disconnectSocialNetwork('facebook', selectedClient.id);
                      }}>
                      <Unplug className="h-4 w-4" />
                      Disconnect
                    </Button>
                  </>
                ) : (
                  <Badge className="bg-amber-100 text-amber-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                    <X className="h-4 w-4 mr-1.5" /> Disconnected
                  </Badge>
                )}
              </div>
            </div>

            {/* Instagram */}
            <div className="p-5 rounded-xl border-2 border-border bg-background hover:border-primary/30 transition-colors">
              <div className="flex items-center gap-4 mb-4">
                <div className="h-14 w-14 rounded-full bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 flex items-center justify-center shadow-lg flex-shrink-0">
                  <Instagram className="h-7 w-7 text-white" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-lg">Instagram</p>
                  {links?.Instagram_URL &&
                  selectedClient.socialnetworks.instagramPage ? (
                    <a
                      className="text-sm text-muted-foreground truncate block"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={links?.Instagram_URL}>
                      {selectedClient.socialnetworks.instagramPage}
                    </a>
                  ) : (
                    <p className="text-sm text-muted-foreground truncate">
                      Not connected
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between gap-3">
                {links?.Instagram_URL &&
                selectedClient.socialnetworks.instagramPage ? (
                  <>
                    <Badge className="bg-green-100 text-green-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" /> Connected
                    </Badge>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      className="text-destructive hover:text-destructive hover:bg-destructive/10 gap-2 rounded-lg"
                      style={{
                        background: 'none',
                        cursor: 'pointer',
                        outline: 'inherit'
                      }}
                      onClick={() => {
                        disconnectSocialNetwork('instagram', selectedClient.id);
                      }}>
                      <Unplug className="h-4 w-4" />
                      Disconnect
                    </Button>
                  </>
                ) : (
                  <Badge className="bg-amber-100 text-amber-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                    <X className="h-4 w-4 mr-1.5" /> Disconnected
                  </Badge>
                )}
              </div>
            </div>

            {/* Google */}
            <div className="p-5 rounded-xl border-2 border-border bg-background hover:border-primary/30 transition-colors">
              <div className="flex items-center gap-4 mb-4">
                <div className="h-14 w-14 rounded-full bg-white flex items-center justify-center shadow-lg flex-shrink-0">
                  <svg className="h-7 w-7" viewBox="0 0 24 24">
                    <path
                      fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-lg">Google</p>
                  {selectedClient.socialnetworks
                    ?.googleMyBusinessLocationName &&
                  (links?.GMB_Google_2_URL ||
                    links?.Google_Business_Listing_URL) ? (
                    <a
                      className="text-sm text-muted-foreground truncate block"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        links?.GMB_Google_2_URL ||
                        links?.Google_Business_Listing_URL
                      }>
                      {
                        selectedClient.socialnetworks
                          .googleMyBusinessLocationName
                      }
                    </a>
                  ) : (
                    <p className="text-sm text-muted-foreground truncate">
                      Not connected
                    </p>
                  )}
                </div>
              </div>
              <div className="flex items-center justify-between gap-3">
                {selectedClient.socialnetworks?.googleMyBusinessLocationName &&
                (links?.GMB_Google_2_URL ||
                  links?.Google_Business_Listing_URL) ? (
                  <>
                    <Badge className="bg-green-100 text-green-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                      <CheckCircle2 className="h-4 w-4 mr-1.5" /> Connected
                    </Badge>
                    <Button
                      type="button"
                      variant="outline"
                      size="sm"
                      className="text-destructive hover:text-destructive hover:bg-destructive/10 gap-2 rounded-lg"
                      style={{
                        background: 'none',
                        cursor: 'pointer',
                        outline: 'inherit'
                      }}
                      onClick={() => {
                        disconnectSocialNetwork(
                          'googleMyBusiness',
                          selectedClient.id
                        );
                      }}>
                      <Unplug className="h-4 w-4" />
                      Disconnect
                    </Button>
                  </>
                ) : (
                  <Badge className="bg-amber-100 text-amber-700 border-0 px-3 py-1.5 text-sm font-medium rounded-full">
                    <X className="h-4 w-4 mr-1.5" /> Disconnected
                  </Badge>
                )}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Dialog Modals */}
      <Dialog open={disconnectModalOpen} onOpenChange={setDisconnectModalOpen}>
        <DialogContent className="sm:max-w-md text-center py-10">
          <DialogHeader className="items-center">
            <DialogTitle className="text-2xl font-bold text-foreground">
              {`Disconnect ${networkToDisconnect}`}
            </DialogTitle>
            <DialogDescription className="text-base text-muted-foreground mt-2">
              {`Are you sure you want disconnect ${networkToDisconnect}?`}
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center gap-3 mt-4">
            <Button
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
              onClick={confirmDisconnect}>
              OK
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setDisconnectModalOpen(false);
                setNetworkToDisconnect('');
              }}
              className="px-8 h-11 text-base font-semibold rounded-lg">
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={disconnectSuccessModalOpen}
        onOpenChange={(open) => {
          if (!open) {
            history.go(0);
          }
        }}>
        <DialogContent className="sm:max-w-md text-center py-10">
          <DialogHeader className="items-center">
            <DialogTitle className="text-2xl font-bold text-foreground">
              Success!
            </DialogTitle>
            <DialogDescription className="text-base text-muted-foreground mt-2">
              Disconnected!
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center mt-4">
            <Button
              className="bg-primary hover:bg-primary/90 text-primary-foreground px-8 h-11 text-base font-semibold rounded-lg"
              onClick={() => history.go(0)}>
              OK
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Links;
